import camelCase from 'lodash/camelCase';
export var formatProductForOperation = function formatProductForOperation(product) {
  return camelCase(product);
};
export var getOperationName = function getOperationName(product) {
  return "".concat(formatProductForOperation(product), "_activity_recentWorkClient");
};